import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './lp.css';
import styles from "./lp.styles";

const LeftHero = () => {
    const location = useLocation();
    const user = location.state?.user;
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            console.log(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="left-section" style={screenWidth > 1124 ? styles.leftSection : styles.leftSectionResp}>
            <div className="left-common-div" style={{ paddingLeft: "10px",marginLeft:"10px" }}>
                <div data-aos="fade-right" data-aos-duration="800">
                    <div className="upper-head-div">
                        <h2 className="f-w-700 heading2-base text-shadow">
                            POWER YOUR WORLD:
                        </h2>
                        <h2 className="f-w-700 heading2-tokens text-shadow">
                            REM TOKENS
                        </h2>
                    </div>
                    <div style={screenWidth > 1124 ? styles.divider : styles.dividerResp}></div>
                    <h1 className="f-w-900 main-heading text-shadow" style={{ marginTop: "-10px", ...styles.mainHeading }}>
                        REM ENCRYPTED{screenWidth > 1124 && <br />} ASSETS{screenWidth > 1124 && <br />} ECOSYSTEM
                    </h1>


                    <div style={screenWidth > 1124 ? styles.divider : styles.dividerResp}></div>
                    <h4 className="f-w-700 text-shadow sub-heading sub-heading-LH" style={{ margin: screenWidth > 1124 ? "10px 0px 20px 0px" : '0px', textAlign: screenWidth < 1124 ? 'center' : "", }}>
                        Welcome to REM Eco-Tech's Vision for a <br /> Net Zero, Decentrailized Energy Horizon
                    </h4>
                </div>
            </div>
            <div className="button-div-LH">
                <div style={{ height: "130px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <button className="text-shadow button-LH" style={{ width: "250px", height: "60px" }}>
                        <h6 className="f-w-700 text-shadow button-text-LH">WHITEPAPER</h6>
                    </button>
                </div>
                <div style={{ height: "130px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <button className="text-shadow button-LH" style={{ width: "250px", height: "60px" }}>
                        <h6 className="f-w-700 text-shadow button-text-LH">TOKENOMICS</h6>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeftHero;
